import React from "react";
import { useParams } from "react-router-dom";
import { FragmentationTab } from "./../FragmentationTab";

export default function FragmentationPage() {
  const { projectId } = useParams();

  return (
    <div>
      <FragmentationTab projectId={projectId} active={true} />
    </div>
  );
}
